import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"

// Server-side unpin for the home Pinned cards. The × DELETEs /pins/:id and,
// on success, drops the card from the DOM. The lazy Events card lives inside a
// turbo-frame, so we remove the enclosing reorder slot / frame rather than
// leaving an empty grid cell. Replaces the old localStorage-based home-pins
// controller — an unpin now persists across devices.
export default class extends Controller {
    static values = { url: String }

    remove(event) {
        event.preventDefault()
        event.stopPropagation()
        const target = this.element.closest("[data-pin-id]") ||
            this.element.closest("turbo-frame") ||
            this.element.closest(".home-pin-card")
        fetch(this.urlValue, {
            method: "DELETE",
            headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
            credentials: "same-origin"
        })
            .then((response) => { if (response.ok) target?.remove() })
            .catch(() => {})
    }
}
